/**
 * Profile guidance placement — sidebar when wide + expanded, inline otherwise.
 */
import React from 'react';
import { PersonArchiveInsightPanel } from './PersonArchiveInsightPanel';

export function PersonProfileSidebarInsight({
  collapsed,
  onExpand,
  onCollapse,
  ...props
}) {
  return (
    <PersonArchiveInsightPanel
      {...props}
      placement="sidebar"
      collapsed={collapsed}
      onExpand={onExpand}
      onCollapse={onCollapse}
    />
  );
}

export function PersonProfileInlineInsight({
  collapsed,
  isWide,
  onExpand,
  onCollapse,
  ...props
}) {
  if (isWide) return null;
  return (
    <PersonArchiveInsightPanel
      {...props}
      placement="inline"
      collapsed={collapsed}
      onExpand={onExpand}
      onCollapse={onCollapse}
    />
  );
}
